import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Value from './value';
import { formatWithCommas } from 'helpers/formatters/number_formats';
import { getAreaUnitsLabel } from 'bundles/apex/deals/helpers/labels';

export function AreaValue({ deal, name }) {
  let value;
  if (deal[name]) {
    value = formatWithCommas(deal[name]);

    const unitsLabel = getAreaUnitsLabel(deal[`${name}Units`]);
    if (unitsLabel) {
      value = `${value} ${unitsLabel}`;
    }
  }

  return <Value name={name} value={value} />;
}

AreaValue.propTypes = {
  deal: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(AreaValue);
